module.exports = __webpack_public_path__ + "img/defeat.8bfd15a6.png";